import { getUser, searchUserByPhone, sendOtp, verifyOtp } from '@api/auth';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AuthState, EnterPhoneFormInputs, LoginOtpParams } from '@utils/types';
import Cookies from 'js-cookie';
import { setUserDetails } from './user.slice';

const initialState: AuthState = {
  userId: '',
  userVendorId: '',
  phoneNo: '',
  stage: 'phone',
};

export const loginByPhone = createAsyncThunk(
  'loginByPhone',
  async (loginPayload: EnterPhoneFormInputs) => {
    const userObj = await searchUserByPhone(loginPayload);
    if (userObj === false || userObj.status === 'failed') {
      return false;
    }
    const otpSent = await sendOtp(loginPayload.contactNumber);

    if (otpSent === false) {
      return otpSent;
    }

    return {
      phoneNo: loginPayload.contactNumber,
      userId: userObj.id,
      userVendorId: userObj.vendor_id,
    };
  },
);

export const optVerification = createAsyncThunk(
  'optVerification',
  async (otpPayload: LoginOtpParams, { dispatch }) => {
    const verified = await verifyOtp(otpPayload.userId, otpPayload.otp);
    if (verified === false) {
      return verified;
    }

    // fetch user details
    Cookies.set('ca_token', verified.token);
    Cookies.set('uuid_dp', otpPayload.userId);

    const userDetails = await getUser(otpPayload.userVendorId);

    if (userDetails?.data?.id === undefined) {
      Cookies.remove('ca_token');
      Cookies.remove('uuid_dp');
      return false;
    }

    dispatch(
      setUserDetails({
        ...userDetails?.data?.attributes,
        phoneNo: otpPayload.phoneNo,
      }),
    );

    return true;
  },
);

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.userId = '';
      state.phoneNo = '';
      state.stage = 'phone';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      loginByPhone.fulfilled,
      (state: AuthState, action: PayloadAction<AuthState>) => {
        if (action.payload) {
          state.userId = action.payload.userId;
          state.userVendorId = action.payload.userVendorId;
          state.phoneNo = action.payload.phoneNo;
          state.stage = 'otp';
        }
      },
    );
  },
});

// Action creators are generated for each case reducer function
export const { resetAuthState } = authSlice.actions;

export default authSlice.reducer;
